export default __webpack_public_path__ + "static/media/mt-icon.9938a5dd.svg";